module.exports = __webpack_public_path__ + "static/img/pdd1.67ff5423.png";